import { useRef } from "react";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
import { bindForwardedRef } from "@givebutter/react-util";
//#region src/textarea/Textarea.tsx
const resizeToContent = (node) => {
	node.style.height = "auto";
	node.style.height = `${node.scrollHeight}px`;
};
const Textarea = ({ ref, onInput: onInputConsumer, className, autoResize = false, isError, ...restProps }) => {
	const textareaRef = useRef(null);
	const onInput = (e) => {
		onInputConsumer?.(e);
		if (textareaRef.current && autoResize) resizeToContent(textareaRef.current);
	};
	return /* @__PURE__ */ jsx("textarea", {
		ref: (node) => {
			textareaRef.current = node;
			bindForwardedRef(ref, node);
			if (node && autoResize) resizeToContent(node);
		},
		onInput,
		className: twMerge("resize-none rounded-lg border-none bg-white p-3 leading-4 ring-1 ring-gray-300 outline-hidden ring-inset", "focus:ring-2 focus:ring-blue-500", "disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-300 disabled:placeholder:text-gray-200", "placeholder:text-gray-400", isError && "ring-2 ring-red-500", autoResize && "overflow-y-hidden", className),
		"aria-invalid": isError || void 0,
		...restProps
	});
};
const Root = Textarea;
//#endregion
export { Root, Textarea };
